import materialColors from 'vuetify/es5/util/colors';
let colors = Object.keys(materialColors)
  .filter((color) => materialColors[color].accent1)
  .map((color) => materialColors[color].accent1);

export default () => {
  const color = colors[Math.floor(Math.random() * colors.length)];

  return color;
};
